var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav-bar',{attrs:{"list":_vm.nav}}),_c('div',{staticClass:"main"},[_c('div',{staticClass:"main-context"},[(_vm.art)?_c('article-detail',{attrs:{"art":_vm.art,"nextArt":_vm.nextArt,"prevArt":_vm.prevArt}}):_vm._e()],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }